// ------------------------ utility ------------------------ //

getQueryParams = function () {
    return (new URL(window.location.href)).searchParams
}

getQueryParam = function (name) {
    return getQueryParams().get(name)
}

setCookie = function (name, value, expireSeconds = 86400) {
    let expires = ''

    if (expireSeconds) {
        let date = new Date()

        date.setTime(date.getTime() + expireSeconds * 1000)

        expires = '; expires=' + date.toUTCString()
    }

    document.cookie = name + '=' + (value || '') + expires + ';domain=.' + document.location.host + ';path=/'
}

readCookie = function(name) {
    const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1];

    if (cookieValue) {
        return decodeURIComponent(cookieValue);
    }

    return null;
}

// path = `value` OR `nested.value`
getObjectValue = function (object, path) {
    const keys = path.split('.')
    let result = object

    for (let key of keys) {
        result = result[key]

        if (result === undefined) {
            return undefined
        }
    }

    return result
}

setObjectValue = function (object, path, value) {
    const keys = path.split('.')
    let result = object

    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i]

        if (result[key] === undefined) {
            result[key] = {} // Create nested object if it doesn't exist
        }

        result = result[key]
    }

    result[keys[keys.length - 1]] = value
}

getFirstElementFromArray = function (a) {
    return a.at(0)
}

getLastElementFromArray = function (a) {
    return a.at(-1)
}

isViewportMobile = function () {
   return window.matchMedia('(max-width: 767px)').matches
}

// ------------------------ dom ------------------------ //

loadScript = async function (url) {
    return new Promise((resolve, reject) => {
        const element = document.createElement('script')
        element.src = url;
        element.type = 'text/javascript'
        element.async = true;
        element.onload = () => resolve()
        element.onerror = () => reject()
        document.head.appendChild(element)
    })
}

// loadScript = function (url, callback) {
//     const scriptJS = document.createElement('script')
//     scriptJS.type = 'text/javascript';
//     scriptJS.src = url;
//     scriptJS.addEventListener('load', callback)
//     document.head.appendChild(scriptJS)
// }

smoothScrollingTo = function (targetElement, offset = 0) {
    if (targetElement) {
        const element = document.querySelector(targetElement)

        if (element) {
            // Calculate the top offset of the element
            const elementTop = element.getBoundingClientRect().top + window.scrollY

            // Scroll to the calculated position with the offset
            window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth' // Smooth scrolling
            })
        }
    }
}

wrapElement = function (element, wrapper) {
    element.parentNode.insertBefore(wrapper, element)
    wrapper.appendChild(element);
}

createElementFromHTML = function (htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    return div.firstChild;
}

returnButtonProcessing = function(text = 'Processing...') {
    return ''
        + '<svg class="inline-block animate-spin mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">'
            + '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>'
            + '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>'
        + '</svg>'
        + ' ' + text
}

preventDefault = function(event) {
    event.preventDefault()
}

// ------------------------ system ------------------------ //

let jsConfig

getConfigValue = function(path) {
    if (typeof jsConfig == 'undefined') {
        jsConfig = readCookie('jsConfig') // jsConfig (eg: json_encoded([]) is set as cookie via SetupCookies
        jsConfig = decodeURIComponent(jsConfig)
        jsConfig = JSON.parse(jsConfig)
    }

    return getObjectValue(jsConfig, path)
}

debug = function (...args) {
    if (getConfigValue('environment') !== 'production') {
        console.log(...args)
    }
}

// ------------------------ form ------------------------ //

// ------------------------ form ------------------------ //

toggleLoading = function (inputElement, is_loading) {
    inputElement.classList.remove('is-invalid')
    inputElement.classList.remove('is-valid')

    applyToggle(inputElement, 'loading', is_loading)
}

toggleValid = function (inputElement, is_valid) {
    if (is_valid === true) {
        inputElement.classList.remove('is-invalid')
        inputElement.classList.add('is-valid')

        applyToggle(inputElement, 'valid', true, true)
    } else {
        inputElement.classList.add('is-invalid')
        inputElement.classList.remove('is-valid')

        applyToggle(inputElement, 'invalid', true, true)
    }
}

applyToggle = function(inputElement, toggleAction, is_active, useFocus = false) {
    let elementToggleContainer = document.querySelector('#toggle-container-' + inputElement.id)

    if (!elementToggleContainer) {
        if (is_active) {
            // Create toggle container if it doesn't exist
            elementToggleContainer = document.createElement('div')
            elementToggleContainer.id = 'toggle-container-' + inputElement.id
            elementToggleContainer.classList.add('toggle-container')
            wrapElement(inputElement, elementToggleContainer)

            if (useFocus === true) {
                inputElement.focus()

                if (['text', 'email'].includes(inputElement.type) === true) {
                    const value = inputElement.value
                    inputElement.value = '' // Temporarily clear the value to reset the cursor position
                    inputElement.value = value // Restore the value, cursor is now at the end
                }
            }

        } else {
            return
        }
    }

    let elementToggleContent = elementToggleContainer.querySelector('.toggle-content')

    if (typeof (elementToggleContent) !== 'undefined' && elementToggleContent !== null) {
        elementToggleContent.remove()
    }

    if (is_active) {
        setToggleContent(toggleAction, elementToggleContainer)
    }
}

setToggleContent = function(toggleAction, elementToggleContainer) {
     // Load toggle content from hidden div which should be present in the template
    let elementToggleContent = createElementFromHTML(document.querySelector('#toggle-' + toggleAction).innerHTML)

    elementToggleContainer.appendChild(elementToggleContent)
}
